import React from 'react';
import useForm from 'components/use-form';
import { AgencyDetailProps } from '../../use-agency-detail';
import { ContactInfo } from 'model/agency';
import { contactInfoFormConfig } from '../config';

const ContactInfo: React.FC<AgencyDetailProps> = (props) => {
  let data = props.data?.contact_info || {};
  data = { ...data, authorize_file: props.data?.authorize_file };

  const { Form } = useForm({
    data,
    mode: 'text',
    title: '联系人信息',
    config: contactInfoFormConfig,
  });

  return Form;
};

export default ContactInfo;
